<div class="more-info-container">
  <!-- Header Section -->
  <!-- <div class="exam-header">
    <div class="container-fluid px-0">
      <div class="navbar"> -->
        <!-- Logo -->
        <!-- <div class="navbar-brand">
          <a href="/">
            <img
              class="logo"
              src="../../../../assets/images/logo.png"
              alt="Logo"
            />
          </a>
        </div>
      </div>
    </div>
  </div> -->
  <!-- Header Section End -->

  <!-- Header Section -->
  <app-exam-header></app-exam-header>
  <!-- Header Section End -->


  <!-- Content Section -->
  <div class="content">
    <!-- Section 1: Community Invitation - Directly on page background -->
    <section class="mindset-community black-background">
      <!-- <div class="animated-bg">
        <div class="bg-circle circle-1"></div>
        <div class="bg-circle circle-2"></div>
        <div class="bg-circle circle-3"></div>
      </div> -->
      
      <div class="section-content">
        <h2 class="section-title text-center">
          You're Invited to the
          <span class="hashtag">#MyMindsetShift</span> Community!
        </h2>
        <p class="subtitle">Because your journey deserves to be celebrated.</p>

        <div class="achievement-section">
          <div class="achievement-icon">
            <span>🎯</span>
          </div>
          <div class="achievement-text">
            <p>
              You've completed your Mindset Shift workbook - or taken your first
              step - and that deserves recognition!
            </p>
            <p>Growth is powerful, but it's even more fulfilling when shared.</p>
          </div>
        </div>

        <div class="benefits-section">
          <h3>
            Join our online community using
            <span class="hashtag">#MyMindsetShift</span> to:
          </h3>
          <div class="benefits-tiles">
            <div class="benefit-tile">
              <div class="benefit-icon">✨</div>
              <p>Celebrate your milestones</p>
            </div>
            <div class="benefit-tile">
              <div class="benefit-icon">🌱</div>
              <p>Share daily wins, challenges, and mindset breakthroughs</p>
            </div>
            <div class="benefit-tile">
              <div class="benefit-icon">💫</div>
              <p>Inspire others with your story</p>
            </div>
            <div class="benefit-tile">
              <div class="benefit-icon">🤝</div>
              <p>Connect with like-minded people on the same path</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 2: Power Word Practice -->
    <section class="power-word-section">
      <h2 class="section-title">The 'Power Word' Practice</h2>
      <p class="subtitle">
        Start your day with a word that shapes your energy and intention.
      </p>
      <div class="feature-grid">
        <div class="feature-item">
          <div class="feature-icon">🔍</div>
          <div class="feature-content">
            <h4 class="feature-title">Choose Your Word</h4>
            <p class="feature-text">
              Select one word that defines how you want to feel that day.
            </p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">✨</div>
          <div class="feature-content">
            <h4 class="feature-title">Be Authentic</h4>
            <p class="feature-text">
              'Focus', 'Grace', 'Joy'—whatever resonates with you.
            </p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">💬</div>
          <div class="feature-content">
            <h4 class="feature-title">Embody Your Word</h4>
            <p class="feature-text">
              Write it down. Say it aloud. Let it shape your day.
            </p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon">🧭</div>
          <div class="feature-content">
            <h4 class="feature-title">Let It Guide You</h4>
            <p class="feature-text">
              Use it as a compass for your energy and choices.
            </p>
          </div>
        </div>
      </div>

      <div class="journal-intro">
        <div class="glow-card">
          <p>
            Below is your 30-day Power Word Journal. Each day, choose your word
            and note why you chose it.
          </p>
          <div class="example">
            <h4><span class="highlight">Example:</span></h4>
            <p>
              Day 1 – Power Word:
              <strong class="highlight-word">Courage</strong> | Why: I have an
              important presentation and want to speak with confidence.
            </p>
          </div>
          <div class="toggle-journal-wrapper">
            <button
              type="button"
              class="toggle-journal-btn"
              (click)="downloadPowerWordJournal()"
            >
              <span class="btn-text">Download Journal PDF</span>
              <i class="fas fa-download"></i>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 3: Mindset Cards -->
    <section class="mindset-cards-section">
      <h2 class="section-title">Mindset Reflection Cards</h2>
      <p class="subtitle">Daily prompts to deepen your mindset practice</p>

      <div class="cards-intro">
        <p>
          Choose a card that resonates with your current journey. Use the
          affirmation, reflection question, and author's insight to guide your
          mindset practice for the day.
        </p>
      </div>

      <div class="cards-container">
        <!-- Card 1: Resilience -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Resilience</h3>
            <div class="affirmation">
              <p>I rise stronger each time I fall.</p>
            </div>
            <div class="reflection">
              <p>
                What challenge did I overcome today, and what strength did it
                reveal?
              </p>
            </div>
            <div class="whisper">
              <p>Every bruise holds a blessing—wear yours with pride.</p>
            </div>
          </div>
        </div>

        <!-- Card 2: Gratitude -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Gratitude</h3>
            <div class="affirmation">
              <p>I see the beauty in the small things.</p>
            </div>
            <div class="reflection">
              <p>What simple moment made my heart smile today?</p>
            </div>
            <div class="whisper">
              <p>Joy begins when gratitude becomes a habit.</p>
            </div>
          </div>
        </div>

        <!-- Card 3: Growth -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Growth</h3>
            <div class="affirmation">
              <p>I embrace progress, not perfection.</p>
            </div>
            <div class="reflection">
              <p>What did I learn today that will help me grow tomorrow?</p>
            </div>
            <div class="whisper">
              <p>The tiny wins are still steps forward—don't discount them.</p>
            </div>
          </div>
        </div>

        <!-- Card 4: Courage -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Courage</h3>
            <div class="affirmation">
              <p>I choose courage over comfort.</p>
            </div>
            <div class="reflection">
              <p>Where did I choose bravery over ease today?</p>
            </div>
            <div class="whisper">
              <p>Courage is found in the quiet 'yes' to try again.</p>
            </div>
          </div>
        </div>

        <!-- Card 5: Self-Compassion -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Self-Compassion</h3>
            <div class="affirmation">
              <p>I speak to myself with kindness.</p>
            </div>
            <div class="reflection">
              <p>
                How would I comfort a friend going through what I faced today?
              </p>
            </div>
            <div class="whisper">
              <p>Be your own soft place to land.</p>
            </div>
          </div>
        </div>

        <!-- Card 6: Clarity -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Clarity</h3>
            <div class="affirmation">
              <p>I know where I'm going and why it matters.</p>
            </div>
            <div class="reflection">
              <p>
                What is one thing I'm doing today that aligns with my purpose?
              </p>
            </div>
            <div class="whisper">
              <p>Clarity creates confidence—return to your 'why' often.</p>
            </div>
          </div>
        </div>

        <!-- Card 7: Discipline -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Discipline</h3>
            <div class="affirmation">
              <p>I do what needs to be done, even when it's hard.</p>
            </div>
            <div class="reflection">
              <p>What habit am I proud of sticking to today?</p>
            </div>
            <div class="whisper">
              <p>
                Discipline isn't punishment—it's a declaration of your worth.
              </p>
            </div>
          </div>
        </div>

        <!-- Card 8: Vision -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Vision</h3>
            <div class="affirmation">
              <p>I am creating the future I dream of.</p>
            </div>
            <div class="reflection">
              <p>What did I imagine today that lit a spark inside me?</p>
            </div>
            <div class="whisper">
              <p>Your dream isn't random—it's your roadmap.</p>
            </div>
          </div>
        </div>

        <!-- Card 9: Presence -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Presence</h3>
            <div class="affirmation">
              <p>I am here, grounded and aware.</p>
            </div>
            <div class="reflection">
              <p>When today did I feel fully alive in the moment?</p>
            </div>
            <div class="whisper">
              <p>The now holds everything you seek—breathe into it.</p>
            </div>
          </div>
        </div>

        <!-- Card 10: Power -->
        <div class="mindset-card">
          <div class="card-content">
            <h3 class="card-title">Power</h3>
            <div class="affirmation">
              <p>I have everything I need within me.</p>
            </div>
            <div class="reflection">
              <p>
                What choice did I make today that reminded me of my strength?
              </p>
            </div>
            <div class="whisper">
              <p>You are not waiting to become—you already are.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 4: One Sentence Journal -->
    <section class="power-word-section">
      <h2 class="section-title">One Sentence Journal</h2>
      <p class="subtitle">
        Capture your growth journey one powerful insight at a time
      </p>
      <!-- <div class="feature-grid">
                <div class="feature-item">
                <div class="feature-icon">
                    🔍
                </div>
                <div class="feature-content">
                    <h4 class="feature-title">Increases self-awareness</h4>
                </div>
                </div>
                <div class="feature-item">
                <div class="feature-icon">
                    ✨
                </div>
                <div class="feature-content">
                    <h4 class="feature-title">Tracks your growth journey</h4>
                </div>
                </div>
                <div class="feature-item">
                <div class="feature-icon">
                    💬
                </div>
                <div class="feature-content">
                    <h4 class="feature-title">Builds reflection habit</h4>
                </div>
                </div>
                <div class="feature-item">
                <div class="feature-icon">
                    🧭
                </div>
                <div class="feature-content">
                    <h4 class="feature-title">Takes less than a minute</h4>
                </div>
                </div>
            </div> -->

      <div class="journal-intro">
        <div class="glow-card">
          <p>
            Download your 30-day One Sentence Journal template and start
            documenting your mindset journey today.
          </p>
          <div class="example">
            <h4><span class="highlight">Example:</span></h4>
            <div class="example-row">
              <div class="day-label">Day 1</div>
              <p class="example-text">
                "I realised today that I am more patient than I thought when
                things don't go as planned."
              </p>
            </div>
          </div>
          <div class="toggle-journal-wrapper">
            <button
              type="button"
              class="toggle-journal-btn"
              (click)="downloadSentenceJournal()"
            >
              <span class="btn-text">Download Journal PDF</span>
              <i class="fas fa-download"></i>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 5: Closing Message -->
    <section class="closing-message-section">
      <div class="closing-container full-width-container">
        <div class="sparkles sparkle-1"></div>
        <div class="sparkles sparkle-2"></div>
        <div class="sparkles sparkle-3"></div>

        <div class="closing-content">
          <div class="inspiration-section">
            <div class="quote-container">
              <div class="quote-marks">❝</div>
              <div class="inspiration-text">
                <p class="inspiration-highlight">
                  You are not alone in this journey—and your voice can uplift
                  someone else's.
                </p>
                <p>
                  Post your reflections, a quote from the workbook, your
                  one-sentence journal, or your favorite shift moment.
                </p>
                <p class="inspiration-emphasis">
                  Let the world see the transformation that's unfolding in you.
                </p>
              </div>
              <div class="quote-marks quote-marks-end">❞</div>
            </div>
            <div class="inspiration-divider">
              <span class="divider-icon">✨</span>
            </div>
          </div>

          <p class="closing-text">
            This isn't the end. It's the beginning of something big.<br />We
            can't wait to hear your story!
          </p>
          <div class="signature">
            <p>With love and belief in your growth,</p>
            <p class="author">Sharani Ponguru</p>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Content Section End -->

  
</div>
<!-- Footer Section -->
<app-exam-footer></app-exam-footer>
<!-- Footer Section End -->
